// RAWBequest interface for bequest data
export interface RAWBequest {
  fileName: string
  caseNumber: string
  dateOfWill: Date
  name: string
  beneficiaryAddress: string
  bequestTypes: RAWBequestType
  bequestSubType: RAWBequestSubType
  netValue: number
  bequestText: string
  commonBequestText: string
  conditionText: string
  charitableContent: boolean
  beneficiaryType: RAWBeneficiaryType
  benhamClause: boolean
  benhamClauseContent: string
  charityCommissionNumber: number
  storeDate: Date
  organisationName: string
  organisationSubName: string
  clientTag: boolean
  numberOfClients: number
  fuzzyMatchedCharity: string
  trackingId: number
  // Additional UI fields for bequest value management
  notificationType?: string
  pecuniaryValue?: number | null
  residualValue?: number | null
  effectValue?: number | null
  // Proceeds of Sale fields - shown when APOS, CPOS, or POS HAD is selected
  posDescription?: string | null
  posPercentage?: number | null
  posEstimatedValue?: number | null
  isNewlyAdded?: boolean
  isDone?: boolean  // Status checkbox - marks bequest line as done
  wishes?: string  // Wishes field for the bequest
  discretionaryLookup?: string  // Discretionary lookup field - shown when Service Type is DISCRETIONARY
  selectedDiscretionaryActivities?: any[]  // Selected categories with IDs for Discretionary type
  trustLookup?: string  // Trust lookup field - shown when Service Type is TRUST
  // Linked fields - populated from Charity Lookup
  ccnLinked?: string
  addressLinked?: string
  linkedClientStatus?: string  // "Y" or "N" - Client status from Charity Lookup
  // PDF page navigation
  pageNumber?: number  // Page number where this bequest appears in the PDF
  // Display order - determines the order bequests are shown in the app
  indexOrder?: number
}

export enum RAWBeneficiaryType {
  Person,
  Organisation,
  LocalChurch,
  Entity,
  NA

}

export enum RAWBequestType {
  CharitableBequests = 0,
  ConditionalPecuniary = 1,
  ContingentBequests = 2,
  DebtsForgiven = 3,
  Effect = 4,
  IntellectualProperty = 5,
  InvestmentsAndFinancialInstruments = 6,
  Miscellaneous = 7,
  MiscellaneousItems = 8,
  Pecuniary = 9,
  RealProperty = 10,
  Residual = 11,
  NA = 12
}

export enum RAWBequestSubType {
  Absolute,
  AbsoluteCharitableBequests,
  AbsoluteDebtsForgiven,
  AbsoluteEffect,
  AbsoluteInvestmentsAndFinancialInstruments,
  AbsoluteMiscellaneous,
  AbsoluteMiscellaneousItems,
  AbsolutePecuniary,
  AbsoluteResidual,
  Conditional,
  ConditionalCharitableBequests,
  ConditionalEffect,
  ConditionalMiscellaneous,
  ConditionalMiscellaneousItems,
  ConditionalPecuniary,
  ConditionalResidual,
  NA

}
